import React from "react";
import { Paper, Stack, Box } from "@mui/material";
import { Typography } from "@mui/material";
import Contact from "../homepage/Contact";
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <Box sx={{}}>
      <Helmet>
        <title>Privacy Policy</title>
      </Helmet>
      <Paper
        elevation={2}
        sx={{
          padding: "30px",
          margin: {
            xs: "30px",
            lg: "30px 60px",
          },
        }}
      >
        <Stack spacing={3}>
          <Typography
            sx={{
              fontWeight: "bold",
            }}
            variant="h5"
          >
            PRIVACY POLICY
          </Typography>
          <Typography>
            At Conssols your privacy is important. It is committed to respecting
            your privacy and protecting your personally identifiable
            information. Here conssols describes how it uses the information it
            collects for its research purposes. The information is collected
            through the website (www.conssols.herokuapp.com), surveys - both
            online and offline and from third party. It is important that you
            read this Privacy Policy carefully. The word ‘you’ or ‘users’ is
            used to denote visitors who visit the site or use any of its
            services. When you visit Conssols’ website or submit information to
            it whether online or offline, you consent to the use, collection and
            disclosure of the information it has about you in accordance with
            this Privacy Policy.
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
            }}
            variant="h5"
          >
            What is Conssols?
          </Typography>
          <Typography>
            Conssols is the best platform that helps customers to find the best
            construction company related to their projects. Simultaneously, it
            facilitates construction companies to find projects rapidly. This
            website can help both construction companies to meet on a single
            platform for their projects. Our website aims to create a platform
            for construction companies and clients who are looking to build
            house, or something related to construction. If you’re looking for
            construction services providers, it is difficult to find the best
            and nearby construction company. Clients can search for nearby
            companies based on ranking, location, rates, and building/house
            size. These service providers are already registered on this
            platform and clients can get rates from the companies they want.
            Another feature is that the customer can also post a request, and
            then the company will bid on the project and provide the customer
            with an estimated budget, duration, location, and service. Clients
            can also check the contact information of any company.
          </Typography>

          <Typography
            sx={{
              fontWeight: "bold",
            }}
            variant="h5"
          >
            Information Conssols collects
          </Typography>
          <Typography>
            The information conssols collects about the companies and their
            services is through enquiry and research methodologies. conssols
            zeroes in on relevant companies and lists them after appropriation.
            Other companies which are interested in participating in the
            research provide necessary information, testimonials and reviews
            about other companies too. Companies who use Conssols’ services
            create user accounts and user profiles. Conssols will ask you for
            your credit card details if you purchase any of its services.
            Conssols may collect your information through several different
            online and offline channels. It can be via website, through
            Registration forms, user log-ins, emails, in person, over the phone,
            through internal and third-party web based survey tools. The
            personal information it collects in general includes but is not
            limited to name, mailing address, email address, telephone numbers,
            gender, date of birth, occupation, education and other similar
            demographic information. Conssols uses website analytics services
            like Google Analytics to collect data. These services use cookies.
            Most browsers accept cookies automatically by default. When a
            visitor visits Conssols, he consents to the placement of cookies in
            his browser in agreement with Conssols’ Privacy Policy. When you
            visit Conssols’ website, it automatically collects information about
            the timing of your visit, IP address, the pages you visit, the links
            you click on, Operating System, the browser you use, the device you
            use to view our website and the screen resolution of that device.
          </Typography>

          <Typography
            sx={{
              fontWeight: "bold",
            }}
            variant="h5"
          >
            Use of information
          </Typography>
          <Typography>
            Conssols takes and shall take reasonable steps to prevent
            unauthorized or accidental disclosure of your
            personally-identifiable information. Conssols shall not
            intentionally transfer or disclose any of your
            personally-identifiable information to third parties without your
            consent except as follows. Conssols may provide access to your
            personally-identifiable information to third party vendors engaged
            by it only when such vendor first agrees on maintaining the strict
            confidentiality of such information and agrees to provide the same
            level of data security as provided by Conssols. Conssols may
            surrender personal information to affected parties and legal
            authorities if presented with a court order as required and
            permitted by the laws, rules and regulations of any applicable
            jurisdiction in furtherance of potential or on-going legal
            proceedings.
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
            }}
            variant="h5"
          >
            Opt-Out / Unsubscribe / Change, and / or Delete information
          </Typography>
          <Typography>
            Your right to deactivate or delete your account from Conssols is
            subject to our records retention policies and applicable law,
            including any statutory retention requirements. You are well within
            your rights to access, correct, update and/or delete any information
            you submit to the site. However, please note that the company
            profile cannot be deleted once it includes even a single review.
            This is not possible as we cannot delete information that is shared
            by a third-party. If you are not interested in the updates, Direct
            mailers and newsletters from Conssols, you can unsubscribe from
            mailing lists, registrations from the site. You can also contact
            Conssols and ask to unsubscribe. Conssols uses cookies where they
            are necessary for its services or where it has user’s implied or
            express consent. People who visit the site can inspect, block or
            delete cookies with right settings in browsers and with right tools.
            If you are in any way concerned about providing information on
            Conssols website in any manner permitted in Conssols’ Privacy
            Policy, you should refrain from using the website. Write to us in
            case you are concerned about any review or testimonial.
          </Typography>

          <Typography
            sx={{
              fontWeight: "bold",
            }}
            variant="h5"
          >
            Data Security
          </Typography>
          <Typography>
            Conssols takes and implements generally accepted standards of
            technology and operational security to protect your personal
            information from unauthorised access, use, disclosure or loss while
            in transmission or storage. It has both online and offline
            safeguards in place to prevent misuse, destruction and alteration of
            information. Only authorized Conssols’ employees and vendors are
            provided access to personally identifiable information. Systems are
            routinely monitored for potential vulnerabilities and attacks. At
            your end you are advised to keep your login information secure.
          </Typography>

          <Typography
            sx={{
              fontWeight: "bold",
            }}
            variant="h5"
          >
            Data Security
          </Typography>
          <Typography>
            GoodFirms takes and implements generally accepted standards of
            technology and operational security to protect your personal
            information from unauthorised access, use, disclosure or loss while
            in transmission or storage. It has both online and offline
            safeguards in place to prevent misuse, destruction and alteration of
            information. Only authorized GoodFirms’ employees and vendors are
            provided access to personally-identifiable information. Systems are
            routinely monitored for potential vulnerabilities and attacks. At
            your end you are advised to keep your login information secure.
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
            }}
            variant="h5"
          >
            Data Retention
          </Typography>
          <Typography>
            Strategically gathered industry related data remains with us as long
            as we are not specifically asked to remove it. If you have a user
            account, related information is with us for as long as your account
            is active or is needed for legal, regulatory or administrative
            purposes. We may keep your information with us even after you close
            your account to resolve disputes, prevent frauds and abuse or as a
            part of our data backup process.
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
            }}
            variant="h5"
          >
            Video Review Guidelines
          </Typography>
          <Typography>
            The video reviewer can avail the benefit of an incentive ($20 Amazon
            Gift Card) for at most 5 reviews.
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
            }}
            variant="h5"
          >
            Notification of changes
          </Typography>
          <Typography>
            By using (visiting) the GoodFirms’ site, you consent to the
            collection, use and storage of your information by GoodFirms in the
            manner described in this Privacy Policy and elsewhere on the site.
            GoodFirms reserves the right to change, modify, add or remove
            portions of the Privacy Policy at any time, at its discretion. Your
            continued use of the site following the changes in Privacy Policy
            will mean that you accept the changes. If you have any questions
            about GoodFirms Privacy Policy or if you require any assistance in
            navigating the site and reading the provided material, you can
            contact us at: info@goodfirms.co
          </Typography>
        </Stack>
      </Paper>
      <Contact />
    </Box>
  );
};

export default PrivacyPolicy;
